const emojipedia = [
  {
    id: 1,
    emoji: "💪",
    name: "Tense Biceps",
    meaning:
      "“You can do that!” or “I feel strong!” Arm with tense biceps. Also used in connection with doing sports, e.g. at the gym."
  },
  {
    id: 2,
    emoji: "🙏",
    name: "Person With Folded Hands",
    meaning:
      "Two hands pressed together. Is currently very introverted, saying a prayer, or hoping for enlightenment. Is also used as a “high five” or to say thank you."
  },
  {
    id: 3,
    emoji: "🤣",
    name: "Rolling On The Floor, Laughing",
    meaning:
      "This is funny! A smiley face, rolling on the floor, laughing. The face is laughing boundlessly. The emoji version of “rofl“. Stands for „rolling on the floor, laughing“."
  },
  {
    id: 4,
    emoji: "😀",
    name: "Grinning Face",
    meaning:
      "This emoji conveys general pleasure and good cheer or humor."
  },
  {
    id: 5,
    emoji: "😆",
    name: "Grinning Squinting Face",
    meaning:
      "A yellow face with a broad, open smile and scrunched, X-shaped eyes. Often conveys excitement or hearty laughter."
  },
  {
    id: 6,
    emoji: "😋",
    name: "Face Savoring Food",
    meaning:
      "A yellow face with smiling eyes and a broad, closed smile with its tongue sticking out of one corner, as if licking its lips in appetite or contentment. Widely used to convey that a food item is delicious. May also express that a person is attractive."
  },
  {
    id: 7,
    emoji: "🤑",
    name: "Money-Mouth Face",
    meaning:
      "A yellow face with raised eyebrows, dollar signs for eyes, and an open smile sticking out a tongue styled after a green, dollar banknote. Some platforms depict the dollar-sign eyes in green circles."
  },
  {
    id: 7,
    emoji: "😷 ",
    name: "Face with Medical Mask",
    meaning:
      "A yellow face wearing a white surgical mask, as used by health workers in hospitals as well as the general public during a pandemic. May be worn to avoid sickness or spreading airborne diseases."
  },
  {
    id: 7,
    emoji: "🤕 ",
    name: "Face with Head-Bandage",
    meaning:
      "A yellow face with a half-frown and white bandage wrapped around its head, often depicted partially over one eye. May represent physical injury or pain but also emotional hurting, sometimes for ironic effect."
  },
];
export default emojipedia;
